// extracted by mini-css-extract-plugin
export default {"tabContent":"EstimateDetail_tabContent__DxmnP","tabItem":"EstimateDetail_tabItem__Zc4Yg"};